module.exports = __webpack_public_path__ + "static/media/Header_1222.031b0a88.jpg";